module.exports = __webpack_public_path__ + "static/media/PM12.b42b3d70.JPG";